const BUILD_VERSION = '1.0.5'

export const IS_DEVELOPMENT = !process.env.NODE_ENV
  || process.env.NODE_ENV === 'development'
export const IS_PRODUCTION = !IS_DEVELOPMENT
export const env = IS_PRODUCTION ? 'prod' : 'dev'

const Storage = {
  production: 'https://genesysvideos-prd.sescdigital.cloud',
  staging: 'https://genesysvideos-hml.sescdigital.cloud',
  dev: 'https://genesysvideos-dev.sescdigital.cloud',
}
// export const STORAGE_PATH = Storage.dev
// export const STORAGE_PATH = 'https://genesysvideos-hml.sescdigital.cloud'
// export const STORAGE_PATH = 'https://genesys-2021.s3-sa-east-1.amazonaws.com'


const getStoragePath = () => {
  const defaultUrl = Storage.dev

  if (!process || !process.env || !process.env.NODE_ENV) return defaultUrl
  console.log('env', process.env.NODE_ENV)

  switch(process.env.NODE_ENV) {
    case 'production': return Storage.production
    case 'staging': return Storage.staging
    case 'dev': return defaultUrl
    default: return defaultUrl
  }
}

export const STORAGE_PATH = getStoragePath()

console.log({ env: process.env.NODE_ENV, STORAGE_PATH, BUILD_VERSION })
